import { adsPurple } from "../utils/ADSColours";

const ESUState = [
  {
    id: 1,
    osText: "Under construction",
    colour: adsPurple,
  },
  {
    id: 2,
    osText: "Open",
    colour: adsPurple,
  },
  {
    id: 3,
    osText: "Proposed",
    colour: adsPurple,
  },
  {
    id: 4,
    osText: "Permanently closed",
    colour: adsPurple,
  },
];

export default ESUState;
